import angular from 'angular';
import AssetFinanceVehicleModal from './assetFinanceVehicleModal';
import './style.scss';

export default angular
  .module('components.assetFinanceVehicleModal', [])
  .component('assetFinanceVehicleModal', AssetFinanceVehicleModal).name;
